import React from 'react';
import {
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from '@genie-ui/react';

import CYBER_CONSTANT from 'constants/CyberConstants';
import './team-roles-table.scss';

function TeamRolesTable() {
  const {
    TABLE_DATA_HEADER,
    TABLE_DATA_BODY,
  } = CYBER_CONSTANT.TEAM_MANAGEMENT;
  return (
    <Table className="teamRolesTable">
      <TableHead>
        <TableRow>
          {TABLE_DATA_HEADER?.map((headerItem) => (
            <TableCell
              key={headerItem.id}
              className="teamRolesTable__header"
            >
              {headerItem.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {TABLE_DATA_BODY?.map((bodyItem) => (
          <TableRow key={bodyItem?.rowHeader}>
            <TableCell className="teamRolesTable__header">{bodyItem?.rowHeader}</TableCell>
            <TableCell>{bodyItem?.haveGartnerLicense}</TableCell>
            <TableCell>{bodyItem?.viewEditMetrics}</TableCell>
            <TableCell>{bodyItem?.viewOnlineCharts}</TableCell>
            <TableCell>{bodyItem?.changePeerDownload}</TableCell>
            <TableCell>{bodyItem?.inviteToCollab}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default TeamRolesTable;
